// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3d5LK","row":"ProcedureTreatmentSummary_row__3QX0A"};